import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

export interface RefundRequestData {
    actor: 'parent' | 'secretary';
    rib: string;
    amount: number;
    entreprise_team_id?: number;
}

// Créer une demande de remboursement
export const createRefundRequest = async (data: RefundRequestData) => {
    try {
        const response = await axios.post(`${API_URL}/refunds`, data);
        return response;
    } catch (error) {
        console.error('Error creating refund request:', error);
        throw error;
    }
};

// Récupérer toutes les demandes de remboursement (admin)
export const getAllRefundRequests = async () => {
    try {
        const response = await axios.get(`${API_URL}/refunds`);
        return response;
    } catch (error) {
        console.error('Error fetching all refund requests:', error);
        throw error;
    }
};

// Récupérer les demandes d'un utilisateur
export const getUserRefundRequests = async ( user_id: string ) => {
    try {
        const response = await axios.get(`${API_URL}/refunds/user/${user_id}`);
        return response;
    } catch (error) {
        console.error('Error fetching user refund requests:', error);
        throw error;
    }
};

// Mettre à jour le statut d'une demande avec motif de refus
export const updateRefundStatus = async (
    id: number, 
    status: 'accepted' | 'rejected',
    rejection_reason?: string
) => {
    try {
        const response = await axios.put(`${API_URL}/refunds/${id}/status`, { 
            status,
            rejection_reason 
        });
        return response;
    } catch (error) {
        console.error('Error updating refund status:', error);
        throw error;
    }
};

// Récupérer une demande par ID
export const getRefundRequestById = async (id: number) => {
    try {
        const response = await axios.get(`${API_URL}/refunds/${id}`);
        return response;
    } catch (error) {
        console.error('Error fetching refund request:', error);
        throw error;
    }
};